var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bpc-avatar',{attrs:{"avatar-url":_vm.avatarUrl,"username":_vm.name,"size":_vm.size,"width":_vm.width,"height":_vm.height},on:{"img-error":_vm.onImgError}})}
var staticRenderFns = []

export { render, staticRenderFns }